module.exports = ".margin{\r\n    font-size: 26px;\r\n    font-family: 'Times New Roman', Times, serif;\r\n    font-weight: bolder;\r\n}\r\n.shop-by-categories{\r\n    background-color:lightgray;\r\n    margin: 0;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/categories/categories.component.css
// module id = ./src/app/components/categories/categories.component.css
// module chunks = main